import { AppConfig, subscribeToRemoteConfig } from '../config/remoteConfig';

class ApiService {
  constructor() {
    // this.baseURL = 'http://localhost:8000';
    // this.baseURL = 'https://c8lwf80x-8000.inc1.devtunnels.ms/';
    // this.baseURL = 'https://memotrack.pythonanywhere.com/';
    // this.baseURL = 'https://mtbackend.pythonanywhere.com/'
    // this.baseURL = process.env.BACKEND_URL || 'https://app.memotrack.net';
    this.baseURL = 'https://demoapp.memotrack.net';

    this.inFlightRequests = new Map();
    this.unsubscribeFromConfig = subscribeToRemoteConfig((config) => {
      this.baseURL = 'https://demoapp.memotrack.net';
    });
  }
  async request(endpoint, options = {}) {
    const url = endpoint.startsWith('http://') || endpoint.startsWith('https://')
      ? endpoint
      : `${this.baseURL}${endpoint}`;

    const isFormData = (typeof FormData !== 'undefined' && options.body instanceof FormData) || options.isFormData;

    const headers = {
      ...(options.isBlob || isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(options.headers || {}),
    };

    const token = localStorage.getItem('authToken');
    if (token && !options.skipAuth) {
      headers.Authorization = `Token ${token}`;
    }

    const config = {
      ...options,
      headers,
    };

    const getTenantSlug = () => {
      // 1. URL Subdomain is the primary authority for tenant identification
      const hostname = window.location.hostname;
      const parts = hostname.split('.');
      let subSlug = '';

      if (parts.length >= 3) {
        const first = parts[0].toLowerCase();
        if (!['web', 'app', 'www', 'demoapp'].includes(first)) {
          subSlug = first;
        }
      } else if (parts.length === 2 && parts[1] === 'localhost') {
        const first = parts[0].toLowerCase();
        if (first !== 'localhost') {
          subSlug = first;
        }
      }

      if (subSlug) {
        // Detect cross-tenant session mismatch and clear stale data
        const storedSlug = localStorage.getItem('tenant_slug');
        if (storedSlug && storedSlug !== subSlug) {
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          localStorage.removeItem('hospital');
        }
        localStorage.setItem('tenant_slug', subSlug);
        return subSlug;
      }

      // 2. Fallback only when no subdomain is present (e.g. central portal)
      try {
        const hospitalStr = localStorage.getItem('hospital');
        if (hospitalStr) {
          const hospital = JSON.parse(hospitalStr);
          if (hospital.schema_name) {
            localStorage.setItem('tenant_slug', hospital.schema_name);
            return hospital.schema_name;
          }
        }
      } catch (e) { }

      let slug = localStorage.getItem('tenant_slug');
      if (slug) return slug;

      return '';
    };

    const tenantSlug = getTenantSlug();
    if (tenantSlug) {
      config.headers['X-Tenant'] = tenantSlug;
    }

    const isGet = !options.method || options.method.toUpperCase() === 'GET';
    if (!isGet) {
      this.inFlightRequests.clear();
    }
    const isRefresh = options.forceRefresh || (typeof url === 'string' && url.includes('refresh=true'));
    const reqKey = isGet && !options.isBlob && !isRefresh ? `${url}_${JSON.stringify(config.headers)}` : null;

    if (reqKey && this.inFlightRequests.has(reqKey)) {
      return this.inFlightRequests.get(reqKey);
    }

    const fetchPromise = (async () => {
      try {
        const response = await fetch(url, config);
        // Session expired / invalid token or forbidden
        if (response.status === 401 || response.status === 403) {
          let errorMsg = "Your session expired. Please login again.";
          if (response.status === 403) {
            try {
              const errorData = await response.json();
              errorMsg = errorData.error || "Access denied. Please check your permissions.";
            } catch (e) { }
          }

          // Clear local auth data
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');

          // Show message
          alert(errorMsg);

          // Redirect login
          window.location.href = '/';
          return;
        }

        if (!response.ok) {
          let errorMsg = `HTTP error! status: ${response.status}`;
          try {
            const errorData = await response.json();
            errorMsg = errorData.error || errorData.detail || errorData.message || errorMsg;
          } catch (e) { }
          throw new Error(errorMsg);
        }

        if (options.isBlob) {
          return await response.blob();
        }

        if (response.status === 204) {
          return null;
        }

        return await response.json();
      } catch (error) {
        console.error('API request failed:', error);
        throw error;
      } finally {
        if (reqKey) {
          this.inFlightRequests.delete(reqKey);
        }
      }
    })();

    if (reqKey) {
      this.inFlightRequests.set(reqKey, fetchPromise);
    }

    return fetchPromise;
  }

  // Auth endpoints - simplified login
  async login(phoneNumber, mpin, fcmToken = null) {
    try {
      const body = {
        phone: phoneNumber,
        mpin: mpin
      };

      if (fcmToken) {
        body['fcm_token'] = fcmToken;
      }



      const data = await this.request("/api/token-auth/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });


      return data;
    } catch (error) {
      console.error("Login failed:", error);
      throw error;
    }
  }

  async logout() {
    if (this.isLoggingOut) return;
    this.isLoggingOut = true;
    try {
      const token = localStorage.getItem("authToken");

      if (token) {
        await this.request('/api/token-auth/logout/', {
          method: 'POST',
        });
      }
    } catch (error) {
      console.warn("Logout API failed (ignored):", error);
    } finally {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      localStorage.removeItem("hospital");
      localStorage.removeItem('tenant_slug');
      this.isLoggingOut = false;
    }
  }

  async send_otp(phoneNumber, newMpin) {
    return this.request('/api/send-otp/', {
      method: 'POST',
      body: JSON.stringify({
        phone: phoneNumber,
        mpin: newMpin,
      })
    });

  }

  async verifyOtp(phoneNumber, otp) {
    return this.request('/api/reset-password/', {
      method: 'POST',
      body: JSON.stringify({
        phone: phoneNumber,
        otp: otp,
      })
    });
  }


  // Get hospital details by ID (called after login)
  async getHospital(hospitalId) {
    return this.request(`/api/hospitals/${hospitalId}/`);
  }

  // Hospital-specific endpoints
  async getUsers(hospitalId) {
    return this.request(`/api/hospitals/${hospitalId}/users/`);
  }

  async createUser(hospitalId, userData) {
    return this.request(`/api/hospitals/${hospitalId}/users/`, {
      method: 'POST',
      body: JSON.stringify(userData),
    });
  }

  async updateUser(hospitalId, userId, userData) {
    return this.request(`/api/hospitals/${hospitalId}/users/${userId}/`, {
      method: 'PATCH',
      body: JSON.stringify(userData),
    });
  }

  async deleteUser(hospitalId, userId) {
    return this.request(`/api/hospitals/${hospitalId}/users/${userId}/`, {
      method: 'DELETE',
    });
  }

  async getRoles(hospitalId) {
    return await this.request(`/api/hospitals/${hospitalId}/roles/`);
  }


  async createRole(hospitalId, roleData) {
    return this.request(`/api/hospitals/${hospitalId}/roles/`, {
      method: 'POST',
      body: JSON.stringify(roleData),
    });
  }

  async updateRole(hospitalId, roleId, roleData) {
    return this.request(`/api/hospitals/${hospitalId}/roles/${roleId}/`, {
      method: 'PATCH',
      body: JSON.stringify(roleData),
    });
  }

  async deleteRole(hospitalId, roleId) {
    return this.request(`/api/hospitals/${hospitalId}/roles/${roleId}/`, {
      method: 'DELETE',
    });
  }

  async getBlocks(hospitalId) {
    return this.request(`/api/hospitals/${hospitalId}/blocks/`);
  }
  async getBlock(hospitalId, blockId) {
    return this.request(`/api/hospitals/${hospitalId}/blocks/${blockId}/`);
  }

  async createBlock(hospitalId, blockData) {
    return this.request(`/api/hospitals/${hospitalId}/blocks/`, {
      method: 'POST',
      body: JSON.stringify(blockData),
    });
  }

  async updateBlock(hospitalId, blockId, blockData) {
    return this.request(`/api/hospitals/${hospitalId}/blocks/${blockId}/`, {
      method: 'PATCH',
      body: JSON.stringify(blockData),
    });
  }

  async deleteBlock(hospitalId, blockId) {
    return this.request(`/api/hospitals/${hospitalId}/blocks/${blockId}/`, {
      method: 'DELETE',
    });
  }

  async getShifts(hospitalId) {
    return this.request(`/api/hospitals/${hospitalId}/shifts/`);
  }

  async createShift(hospitalId, shiftData) {
    return this.request(`/api/hospitals/${hospitalId}/shifts/`, {
      method: 'POST',
      body: JSON.stringify(shiftData),
    });
  }

  async updateShift(hospitalId, shiftId, shiftData) {
    return this.request(`/api/hospitals/${hospitalId}/shifts/${shiftId}/`, {
      method: 'PATCH',
      body: JSON.stringify(shiftData),
    });
  }

  async deleteShift(hospitalId, shiftId) {
    return this.request(`/api/hospitals/${hospitalId}/shifts/${shiftId}/`, {
      method: 'DELETE',
    });
  }

  // ================= Approver Hierarchies =================
  async getApproverHierarchies(hospitalId) {
    return this.request(`/api/hospitals/${hospitalId}/hierarchies/`);
  }

  async createApproverHierarchy(hospitalId, data) {
    return this.request(`/api/hospitals/${hospitalId}/hierarchies/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateApproverHierarchy(hospitalId, id, data) {
    return this.request(`/api/hospitals/${hospitalId}/hierarchies/${id}/`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  }

  async deleteApproverHierarchy(hospitalId, id) {
    return this.request(`/api/hospitals/${hospitalId}/hierarchies/${id}/`, {
      method: 'DELETE',
    });
  }

  // ================= Memo =================
  async createMemo(hospitalId, memoData) {
    return this.request(`/api/${hospitalId}/create-memo/`, {
      method: 'POST',
      body: JSON.stringify(memoData),
    });
  }

  async updateMemo(hospitalId, memoId, memoData) {

    return this.request(`/api/${hospitalId}/memos/${memoId}/`, {
      method: 'PATCH',
      body: JSON.stringify(memoData),
    });
  }

  async getMemo(hospitalId, memoId) {
    return this.request(`/api/${hospitalId}/memos/${memoId}/`);
  }

  async getUserMemos(hospitalId, queryParams = '') {
    const query = queryParams ? `?${queryParams}` : '';
    return this.request(`/api/${hospitalId}/memos/${query}`);
  }

  async approveMemo(hospitalId, memoId, data) {
    return this.request(`/api/${hospitalId}/memos/${memoId}/approve/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async rejectMemo(hospitalId, memoId, data) {
    return this.request(`/api/${hospitalId}/memos/${memoId}/reject/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async exportSingleMemo(memoId) {
    return this.request(`/api/export/memo/${memoId}/`, {
      isBlob: true,
    });
  }

  async exportMemos(hospitalId, params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    const endpoint = `/api/export/memos/${hospitalId}/${queryParams ? `?${queryParams}` : ''}`;
    return this.request(endpoint, {
      isBlob: true,
    });
  }

  async fetchDashboardJson(jsonUrl) {
    return this.request(jsonUrl, { skipAuth: true });
  }

  // =============== Worker Status =================
  async addWorkerStatus(hospitalId, memoId, data) {
    return this.request(`/api/${hospitalId}/memos/${memoId}/work-status/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async deleteWorkerStatus(hospitalId, memoId, eventId, metadata = {}) {
    return this.request(`/api/${hospitalId}/memos/${memoId}/work-status/`, {
      method: 'DELETE',
      body: JSON.stringify({
        event_type: 'worker_status_delete',
        payload: { event_id: eventId },
        metadata,
      }),
    });
  }

  // ================= Memo Images =================
  async getMemoImages(hospitalId, memoId) {
    return this.request(`/api/${hospitalId}/memos/${memoId}/images/`);
  }

  async uploadMemoImage(hospitalId, memoId, formDataOrPayload) {
    const isFormData = typeof FormData !== 'undefined' && formDataOrPayload instanceof FormData;
    return this.request(`/api/${hospitalId}/memos/${memoId}/images/`, {
      method: 'POST',
      body: isFormData ? formDataOrPayload : JSON.stringify(formDataOrPayload),
    });
  }

  async deleteMemoImage(hospitalId, memoId, imageId) {
    return this.request(`/api/${hospitalId}/memos/${memoId}/images/${imageId}/`, {
      method: 'DELETE',
    });
  }



  async getWards(hospitalId) {
    return this.request(`/api/hospitals/${hospitalId}/wards/`);
  }

  async getWardsByBlock(hospitalId, blockId) {
    return this.request(`/api/hospitals/${hospitalId}/wards/?block=${blockId}`);
  }

  async switchWard(wardId) {
    return this.request('/api/switch-ward/', {
      method: 'POST',
      body: JSON.stringify({ ward_id: wardId }),
    });
  }

  async switchBlock(blockId) {
    return this.request('/api/switch-block/', {
      method: 'POST',
      body: JSON.stringify({ block_id: blockId }),
    });
  }

  async refreshUser() {
    return this.request('/api/refresh-user/', {
      method: 'POST',
    });
  }

  async createWard(hospitalId, wardData) {
    return this.request(`/api/hospitals/${hospitalId}/wards/`, {
      method: 'POST',
      body: JSON.stringify(wardData),
    });
  }

  async updateWard(hospitalId, wardId, wardData) {
    return this.request(`/api/hospitals/${hospitalId}/wards/${wardId}/`, {
      method: 'PATCH',
      body: JSON.stringify(wardData),
    });
  }

  async deleteWard(hospitalId, wardId) {
    return this.request(`/api/hospitals/${hospitalId}/wards/${wardId}/`, {
      method: 'DELETE',
    });
  }

  // helpers for otp verifications

  async refreshOTP(hospitalId, memoId) {
    return this.request(`/api/${hospitalId}/memos/${memoId}/refresh-otp/`, {
      method: 'POST',
    });
  }

  async getDashboardMemos(hospitalId, queryParams = '') {
    return this.request(`/api/${hospitalId}/dashboard-memos/?${queryParams}`, {
      method: 'GET'
    });
  }

  async createFeedback(payload) {
    return this.request('/api/feedback/create/', {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  async getFeedbacks(page = 1) {
    return this.request(`/api/feedback/list/?page=${page}`, {
      method: 'GET'
    });
  }

  async getUserActivities(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.page_size) queryParams.append('page_size', params.page_size);
    if (params.cursor) queryParams.append('cursor', params.cursor);
    if (params.name_search) queryParams.append('name_search', params.name_search);
    if (params.role_search) queryParams.append('role_search', params.role_search);
    if (params.phone_search) queryParams.append('phone_search', params.phone_search);
    if (params.user_id) queryParams.append('user_id', params.user_id);
    if (params.status) queryParams.append('status', params.status);

    const queryString = queryParams.toString();
    const url = queryString ? `/api/activity/?${queryString}` : `/api/activity/`;
    return this.request(url);
  }

  async getUserActivityStats() {
    return this.request('/api/activity/stats/');
  }

  async getUserActivity(userId) {
    return this.request(`/api/activity/${userId}/`);
  }

  async updateNotificationStatus(messageId, status, platform = 'WEB', tenantSlug = null) {
    if (!messageId) return;
    const options = {
      method: 'POST',
      body: JSON.stringify({
        message_id: messageId,
        status: status,
        platform: platform,
        tenant_slug: tenantSlug || ''
      })
    };
    if (tenantSlug) {
      options.headers = { 'X-Tenant': tenantSlug };
    }
    try {
      return await this.request('/api/activity/notification-status/', options);
    } catch (err) {
      console.warn('[FCM Tracking] Failed to update notification status:', err);
    }
  }

  async getFCMLogs(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.status) queryParams.append('status', params.status);
    if (params.platform) queryParams.append('platform', params.platform);
    if (params.search) queryParams.append('search', params.search);
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);

    const queryString = queryParams.toString();
    const url = queryString ? `/api/activity/fcm-logs/?${queryString}` : `/api/activity/fcm-logs/`;
    return this.request(url);
  }

  async getOTPLogs(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.status) queryParams.append('status', params.status);
    if (params.purpose) queryParams.append('purpose', params.purpose);
    if (params.delivery_status) queryParams.append('delivery_status', params.delivery_status);
    if (params.search) queryParams.append('search', params.search);
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);

    const queryString = queryParams.toString();
    const url = queryString ? `/api/activity/otp-logs/?${queryString}` : `/api/activity/otp-logs/`;
    return this.request(url);
  }


}

export default ApiService;


